export default __webpack_public_path__ + "static/media/circles.23d17485.svg";